import { Menu, ActionIcon, useMantineTheme } from '@mantine/core';

import { useState } from 'react';

import { ThreeDotsVertical, Plus } from '../../icons';

interface Props {
  onOpenAddRequirement: () => void
}

const FileRequirementsViewDropdown: React.FC<Props> = (props: Props) => {
  const { onOpenAddRequirement } = props;
  const [opened, setOpened] = useState(false);
  const { other: colorVars } = useMantineTheme();

  return (
    <Menu
      opened={opened}
      onChange={setOpened}
      position="bottom-start"
    >
      <Menu.Target>
        <ActionIcon
          onClick={(event) => { setOpened((o) => !o); event.stopPropagation(); }}
          c={colorVars.secondaryIconColor}
          variant='subtle'
        >
          <ThreeDotsVertical />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<Plus />}
          onClick={(event) => { onOpenAddRequirement(); event.stopPropagation(); }}
        >
          Add Requirement
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default FileRequirementsViewDropdown;
